import { messages } from "../i18n/messages.js";
import { AppButton } from "./ui/AppButton.js";

interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
}

export function ErrorState({
  title = messages.session.errorTitle,
  message,
  onRetry,
}: ErrorStateProps) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 p-6 text-center">
      <h2 className="text-lg font-semibold">{title}</h2>
      <p className="max-w-sm text-sm opacity-70">{message}</p>
      {onRetry ? <AppButton onClick={onRetry}>{messages.common.retry}</AppButton> : null}
    </div>
  );
}
